import { EXTERNAL_API_TYPE } from '../../constants';
export const getters = {
    getOrganizationId: state => {
        return state.userData.organizationId;
    },
    getOrganizationName: state => {
        return state.userData.name;
    },
    getOrganizationBBox: state => {
        return state.userData.organizationBBox;
    },
    getUserData: state => {
        return state.userData;
    },
    getUserThemeGroups: state => {
        return state.userData?.themeProfiles;
    },
    getUserInfo: state => {
        return state.userInfo;
    },
    getUserName: state => {
        if (state.userData?.userName) {
            return state.userData.userName.split('@')[0];
        }
        return '';
    },
    getUserBaseLayers: state => {
        return state.userData?.baselayers;
    },
    getUserWozApis: state => {
        return state.userData.apis.filter(a => a.apiType === EXTERNAL_API_TYPE.WOZ);

    },
    getUserWozApiId: state => {
        return state.userWozApiId;
    },
    getUserWozApiData: state => {
        return state.userWozApiData;
    },
    getUserStufApis: state => {
        return state.userData.apis.filter(a => a.apiType === EXTERNAL_API_TYPE.STUFF);
    },
};
